import {Injectable} from '@angular/core'
import {CanLoad, Router} from '@angular/router'
import {ApiUrlService} from '@app/services/api-url.service'
import {AuthService} from '@app/services/auth.service'
import {TOKEN_KEY} from "@environments/environment"
import {Observable, filter, map, take} from 'rxjs'
import {ApiService} from 'src/app/services/api.service'

@Injectable({
  providedIn: 'root',
})
export class AutoLoginGuard implements CanLoad {
  constructor(private apiService: ApiService, private authService: AuthService, private router: Router, private apiUrlService: ApiUrlService) {
  }

  get apiUrl() {
    return this.apiUrlService.apiUrl;
  }

  canLoad(): Observable<boolean> {
    const cookies = this.apiService.extractCookies()
    const token = cookies['backend_auth_token']

    if (token) {
      const payload = this.apiService.extractPayload(token);
      const { user, client, valid_until, scope } = payload

      if (scope.find((e) => e === 'backend') && parseInt(valid_until) > Math.round(new Date().getTime() / 1000)) {
        this.apiService.deleteCookie('backend_auth_token')

        localStorage.setItem('user', JSON.stringify(user))
        localStorage.setItem(TOKEN_KEY, token)

        this.authService.userValue = user
        this.authService.loadToken().then()

        return new Observable((subscriber) => {
          subscriber.next(true);
        });
      } else {
        localStorage.removeItem('user')
        localStorage.removeItem(TOKEN_KEY)
        this.authService.clearUserAndCredentials().then(() => {
          this.authService.loadToken().then()
        });
      }
    }

    return this.authService.isAuthenticated.pipe(filter(val => val !== null), take(1), map(isAuthenticated => {
      if (isAuthenticated) {
        // const encodedLocale = encodeURIComponent(this.langService.getSelected());
        // this.navCtrl.navigateRoot(`/login?locale=${encodedLocale}`);
        this.router.navigateByUrl(`/dashboard`, { replaceUrl: true })
        return true
      } else {
        this.authService.getValidSession().then(async (res) => {
          if (res?.user === null || res?.client === null) {
            await this.authService.clearUserAndCredentials();
            if(res?.forceSingleSignOn){
              this.authService.forceSingleSignOn.next(res?.forceSingleSignOn)
            }

            if (res?.redirectUrl) {
              window.location.href = res.redirectUrl
            } else {
              // window.location.href = this.apiUrl + '/users/sign_in'
            }
          }

          return true
        })
      }
    }))
  }

}
